import React from 'react'
import { CNavGroup, CNavItem, CNavLink, CNavTitle } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import {
	cilLibrary,
	cilList,
	cilPeople,
	cilNotes,
	cilBook,
	cilAccountLogout,
	cilPlus,
	cilUserPlus,
	cilPuzzle,
	cilBarChart,
	cilColumns,
	cilChartLine,
	cilChatBubble,
	cilTablet,
} from '@coreui/icons'

export default class SidebarNav extends React.Component {

	render() {

		return (
			<>
				<NavItem
					menuId="manage_subjects_menu"
					pageId="manage_subjects"
					selected={this.props.selected_menu}
					icon={cilLibrary}
					name="Subjects"
					onClick={(menuId, pageId) => this.props.onMenuClick(menuId, pageId)} />
				<NavItem
					menuId="manage_topics_menu"
					pageId="manage_topics"
					selected={this.props.selected_menu}
					icon={cilNotes}
					name="Topics"
					onClick={(menuId, pageId) => this.props.onMenuClick(menuId, pageId)} />
				<NavItem
					menuId="manage_sub_topics_menu"
					pageId="manage_sub_topics"
					selected={this.props.selected_menu}
					icon={cilBook}
					name="Sub Topics"
					onClick={(menuId, pageId) => this.props.onMenuClick(menuId, pageId)} />
				<NavItem
					menuId="manage_batch_menu"
					pageId="manage_batch"
					selected={this.props.selected_menu}
					icon={cilList}
					name="Batches"
					onClick={(menuId, pageId) => this.props.onMenuClick(menuId, pageId)} />
				<NavItem
					menuId="manage_mentors_menu"
					pageId="manage_mentors"
					selected={this.props.selected_menu}
					icon={cilUserPlus}
					name="Mentors"
					onClick={(menuId, pageId) => this.props.onMenuClick(menuId, pageId)} />
				<NavItem
					menuId="student_list_menu"
					pageId="student_list"
					selected={this.props.selected_menu}
					icon={cilPeople}
					name="Students"
					onClick={(menuId, pageId) => this.props.onMenuClick(menuId, pageId)} />
				<NavItem
					menuId="student_sets_menu"
					pageId="student_sets"
					selected={this.props.selected_menu}
					icon={cilChatBubble}
					name="Message Groups"
					onClick={(menuId, pageId) => this.props.onMenuClick(menuId, pageId)} />
				<NavItem
					menuId="messages_list_menu"
					pageId="messages_list"
					selected={this.props.selected_menu}
					icon={cilTablet}
					name="Messages"
					onClick={(menuId, pageId) => this.props.onMenuClick(menuId, pageId)} />
				<CNavTitle>Reports</CNavTitle>
				<NavItem
					menuId="summary_report_menu"
					pageId="summary_report"
					selected={this.props.selected_menu}
					icon={cilColumns}
					name="Summary"
					onClick={(menuId, pageId) => this.props.onMenuClick(menuId, pageId)} />
				<NavItem
					menuId="top_mentors_report_menu"
					pageId="top_mentors_report"
					selected={this.props.selected_menu}
					icon={cilChartLine}
					name="Top Mentors"
					onClick={(menuId, pageId) => this.props.onMenuClick(menuId, pageId)} />
				<NavItem
					menuId="mentors_summary_report_menu"
					pageId="mentors_summary_report"
					selected={this.props.selected_menu}
					icon={cilColumns}
					name="Mentors Summary"
					onClick={(menuId, pageId) => this.props.onMenuClick(menuId, pageId)} />
				<NavItem
					menuId="doubts_summary_report_menu"
					pageId="doubts_summary_report"
					selected={this.props.selected_menu}
					icon={cilBarChart}
					name="Doubts Summary"
					onClick={(menuId, pageId) => this.props.onMenuClick(menuId, pageId)} />
				<NavItem
					menuId="top_students_report_menu"
					pageId="top_students_report"
					selected={this.props.selected_menu}
					icon={cilChartLine}
					name="Top Students"
					onClick={(menuId, pageId) => this.props.onMenuClick(menuId, pageId)} />
				{/* <NavItem
					menuId="manage_chat_group_menu"
					pageId="manage_chat_group"
					selected={this.props.selected_menu}
					icon={cilChatBubble}
					name="Chat Group"
					onClick={(menuId, pageId) => this.props.onMenuClick(menuId, pageId)} /> */}
			</>
		)
	}
}

function NavItem(props) {

	return (
		<CNavItem>
			<CNavLink
				href="#"
				active={props.menuId == props.selected}
				onClick={() => props.onClick(props.menuId, props.pageId)}>
				<CIcon icon={props.icon} customClassName="nav-icon" />
				{props.name}
			</CNavLink>
		</CNavItem>
	);
}